import { isNumberOnly, isRequired, isRequiredNo, isTextOnly, isValidConversionRate, isValidEmail, isValidFaxNumber, isValidFileSize, isValidPhone, isValidUrl } from "../../utils/Validate";

import { ValidateMessages } from '../../constants/ValidateConstants';
import ValidateField from '../../hooks/useValid';
import { ValidateName } from '../../constants/ValidateNameConstants';

export default function validation(values,assignedEngineer,authPerson) {
  let errors = {};

  errors.distributorName = ValidateField(values.distributorName, ValidateName?.DISTRIBUTOR_NAME,
    ValidateName?.DISTRIBUTOR_NAME, [ValidateName?.REQUIRED]);

  errors.type = ValidateField(values.type, ValidateName?.DISTRIBUTOR_TYPE,
    ValidateName?.DISTRIBUTOR_TYPE, ["isRequiredNo"]);

  errors.country = ValidateField(values.countryId, ValidateName?.COUNTRY,
    ValidateName?.COUNTRY, ["isRequiredNo"]);

  errors.country = ValidateField(values.countryId, ValidateName?.COUNTRY,
    ValidateName?.COUNTRY, ["isRequiredNo"]);

  errors.email = ValidateField(values.email, ValidateName?.EMAIL,
    ValidateName?.EMAIL, [ValidateName?.REQUIRED, "isValidEmail"]);

  errors.assignedEngineer = ValidateField(assignedEngineer, ValidateName?.ASSIGNED_ENGINEER,
    ValidateName?.ASSIGNED_ENGINEER, ["isRequiredNo"]);

  errors.phone = ValidateField(values.phone, ValidateName?.PHONE_NUMBER,
    ValidateName?.PHONE_NUMBER, [ValidateName?.REQUIRED, "isValidPhone"]);

  errors.currency = ValidateField(values.currencyId, ValidateName?.CURRENCY,
    ValidateName?.CURRENCY, ["isRequiredNo"]);

  errors.conversionRate = ValidateField(values.conversionRate, ValidateName?.CONVERSION_RATE,
    ValidateName?.CONVERSION_RATE, [ValidateName?.REQUIRED, "isValidConversionRate"]);

  errors.companyName = ValidateField(values.companyId, ValidateName?.COMPANY_NAME,
    ValidateName?.COMPANY_NAME, ["isRequiredNo"]);

  errors.authorizedPerson = ValidateField(authPerson, ValidateName?.AUTHORIZED_PERSON,
    ValidateName?.AUTHORIZED_PERSON, [ValidateName?.REQUIRED]);

  errors.designation = ValidateField(values.designationId, ValidateName?.POSITION,
    ValidateName?.POSITION, ["isRequiredNo"]);

  if (!isRequired(values?.logoUrl)) {
    errors['logoUrl'] = ValidateMessages?.UPLOAD_LOGO("company");
  }
  if (!isRequired(values?.headerUrl)) {
    errors['headerUrl'] = ValidateMessages?.UPLOAD_LOGO("header");
  }
  if (!isRequired(values?.footerUrl)) {
    errors['footerUrl'] = ValidateMessages?.UPLOAD_LOGO("footer");
  }

  if (isValidFileSize(values?.logo?.fileUpload?.size)) {
    errors["logoFileSize"] = false;
  } else {
    //invalid file size
    errors["logoFileSize"] = ValidateMessages?.FILE_SIZE("File", "500");
  }
  if (isValidFileSize(values?.header?.fileUpload?.size)) {
    errors["headerFileSize"] = false;
  } else {
    //invalid file size
    errors["headerFileSize"] = ValidateMessages?.FILE_SIZE("File", "500");
  }
  if (isValidFileSize(values?.footer?.fileUpload?.size)) {
    errors["footerFileSize"] = false;
  } else {
    //invalid file size
    errors["footerFileSize"] = ValidateMessages?.FILE_SIZE("File", "500");
  }
  if (!errors['logoFileSize'] && !errors['headerFileSize'] && !errors['footerFileSize']) {
    delete errors['logoFileSize']
    delete errors['headerFileSize']
    delete errors['footerFileSize']
  }
  if(values?.distributorPaymentTerms?.length<=0)
    errors["distributorPaymentTerms"] = ValidateMessages?.REQUIRED("Payment terms");
  if(values?.distributorDeliveryTerms?.length<=0)
    errors["distributorDeliveryTerms"] = ValidateMessages?.REQUIRED("Delivery Terms");

  return errors;
}


